
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zur Gruppe «Erfolgskurs» gehören jene Länder, die es von einem exponentiellen
Wachstum zu einer `}<strong parentName="p">{`Fall-Verdopplungszeit von mehr als 200 Tagen`}</strong>{` geschafft
haben – sie sind in der Grafik farblich hervorgehoben. Die Epidemie hat in
diesen Staaten deutliche Spuren hinterlassen, doch heute verzeichnen sie nur
noch wenig neue Infektionen.`}</p>
    <p>{`Covid-19 konnte sich ausgehend von den Epizentren `}<strong parentName="p">{`China`}</strong>{` und `}<strong parentName="p">{`Italien`}</strong>{`
anfänglich schnell ausbreiten, wurde jedoch durch teilweise drastische
Massnahmen eingedämmt. In dieser Gruppe fällt insbesondere die `}<strong parentName="p">{`Schweiz`}</strong>{` auf
mit einem steilen Abfall der Kurve von einem relativ hohen Niveau der
Fallzahlen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;